import { useLang } from "@/i18n";
import { cn } from "@/lib/utils";

const STYLES = {
  none: "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-300 dark:border-slate-700",
  sent: "bg-emerald-100 dark:bg-emerald-950/60 text-emerald-800 dark:text-emerald-300 border-emerald-300 dark:border-emerald-800",
  mock: "bg-violet-100 dark:bg-violet-950/60 text-violet-800 dark:text-violet-300 border-violet-300 dark:border-violet-800",
  error: "bg-red-100 dark:bg-red-950/60 text-red-800 dark:text-red-300 border-red-300 dark:border-red-800",
  cancelled: "bg-rose-100 dark:bg-rose-950/60 text-rose-800 dark:text-rose-300 border-rose-300 dark:border-rose-800",
  new: "bg-amber-100 dark:bg-amber-950/60 text-amber-800 dark:text-amber-300 border-amber-300 dark:border-amber-800",
  linked: "bg-sky-100 dark:bg-sky-950/60 text-sky-800 dark:text-sky-300 border-sky-300 dark:border-sky-800",
  classified: "bg-emerald-100 dark:bg-emerald-950/60 text-emerald-800 dark:text-emerald-300 border-emerald-300 dark:border-emerald-800",
};

export const MyDataBadge = ({ mydata, className, ...props }) => {
  const { t } = useLang();
  const status = mydata?.status || "none";
  return (
    <span data-testid="mydata-status-badge" {...props}
      className={cn("inline-flex items-center gap-1.5 px-2 py-0.5 rounded border text-xs font-semibold uppercase tracking-wider", STYLES[status], className)}>
      <span className="font-heading normal-case tracking-normal">myDATA</span>
      <span>{t(`md_status_${status}`)}</span>
    </span>
  );
};
